// api
import { fetchApi } from '@/api'
// actions
const inventoryProductsAll = (context) => {
  let url = 'inventory/products'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('INVENTORY_PRODUCTS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsForm = (context) => {
  let url = 'inventory/products/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('INVENTORY_PRODUCTS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsShow = (context, payload) => {
  console.log('aquiiiiii')
  let obj = JSON.parse(payload)
  let data = {}
  let url = 'inventory/products/' + obj.id + '/edit'
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('INVENTORY_PRODUCTS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const inventoryProductsCreate = (context, payload) => {
  let url = 'inventory/products'
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('INVENTORY_PRODUCTS_CREATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/products/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_UPDATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/products/' + obj.id
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsAdd = (context, payload) => {
  let obj = JSON.parse(payload)
  var count = prompt('Ingrese la cantidad')
  if (count != null) {
    obj.count = count
    let json = JSON.stringify(obj)
    let url = 'inventory/products/' + obj.id + '/add'
    return fetchApi(url, json, 'POST')
      .then((response) => {
        context.commit('INVENTORY_PRODUCTS_ADD', response)
        location.reload()
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error)
      })
  }
}

const inventoryProductsMinus = (context, payload) => {
  let obj = JSON.parse(payload)
  var count = prompt('Ingrese la cantidad')
  if (count != null) {
    obj.count = count
    let json = JSON.stringify(obj)
    let url = 'inventory/products/' + obj.id + '/minus'
    return fetchApi(url, json, 'POST')
      .then((response) => {
        context.commit('INVENTORY_PRODUCTS_MINUS', response)
        location.reload()
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error)
      })
  }
}

export default {
  inventoryProductsAll,
  inventoryProductsForm,
  inventoryProductsShow,
  inventoryProductsCreate,
  inventoryProductsUpdate,
  inventoryProductsDelete,
  inventoryProductsAdd,
  inventoryProductsMinus
}



// WEBPACK FOOTER //
// ./src/store/modules/inventory/products/actions.js